import { Injectable } from '@angular/core';
import { DatosEnvio } from '../ecommerce-generico/interfaces/envios.interface';

@Injectable({
  providedIn: 'root'
})
export class EnviosService {

  private datosEnvio: DatosEnvio;
  private codigoFlete: string;
  private marcaFlete: string;
  private costoUltimoFlete: number = 0;

  setDatosEnvio(datosDelEnvio: DatosEnvio): void {
    this.datosEnvio = datosDelEnvio;
    if (datosDelEnvio) {
      this.costoUltimoFlete = this.datosEnvio.costo;
    }
  }

  getDatosEnvio(): DatosEnvio {
    return this.datosEnvio;
  }

  setFleteConfig(marcaFlete: string, codigoFlete: string): void {
    this.marcaFlete = marcaFlete;
    this.codigoFlete = codigoFlete;
  }

  getCodigoFlete(): string {
    return this.codigoFlete;
  }

  getMarcaFlete(): string {
    return this.marcaFlete;
  }

  getCostoUltimoFlete(): number {
    return this.costoUltimoFlete;
  }

  resetCostoUltimoFlete(): void {
    this.costoUltimoFlete = 0;
  }
}
